import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-selectors-top',
  templateUrl: './selectors-top.component.html',
  styleUrls: ['./selectors-top.component.scss']
})
export class SelectorsTopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
